import React, { Component } from 'react';
import DateComponent from '../../Components/Book/Time/index';
import hours from '../../Constants/time';

export default class Date extends Component {
	render() {
		return (
			<DateComponent hours={hours} />
		);
	}
}
